/**
 * API Configuration
 * Maneja la URL base de la API según el entorno
 */

// URL de la API del Worker de Cloudflare
// En desarrollo usa la variable de entorno o localhost
// En producción usa la URL del worker deployado
// 2026-06-19: switched default from *.workers.dev to api.jarix.io
// so production traffic lands behind the jarix.io zone WAF, rate
// limits and managed challenges. *.workers.dev still works (the
// worker custom domain is additive); to flip back, just change
// this fallback. Override per-environment with VITE_API_URL.
export const API_BASE_URL = import.meta.env.VITE_API_URL ||
  (import.meta.env.DEV
    ? 'http://localhost:8787'
    : 'https://api.jarix.io'
  );

/**
 * Construye la URL completa para un endpoint
 */
export function getApiUrl(endpoint: string): string {
  // Asegurar que el endpoint empiece con /
  const normalizedEndpoint = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE_URL}${normalizedEndpoint}`;
}

/**
 * Fetch wrapper con manejo de errores
 */
/**
 * Genera la URL del portal de un tenant
 * En desarrollo: usa query params (?tenant=slug)
 * En producción: usa subdominios ({slug}-panel.jarix.io)
 */
export function getTenantPortalUrl(slug: string): string {
  const hostname = window.location.hostname

  // Desarrollo local: usar query params
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${window.location.origin}?tenant=${slug}`
  }

  // Producción: usar subdominio personalizado
  return `https://${slug}-panel.jarix.io`
}

/**
 * Navega al portal de un tenant
 */
export function navigateToTenantPortal(slug: string): void {
  window.location.href = getTenantPortalUrl(slug)
}

/**
 * URL del portal admin
 */
export function getAdminPortalUrl(): string {
  const hostname = window.location.hostname

  // Desarrollo local
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return `${window.location.origin}?admin=true`
  }

  // Producción: hub.jarix.io
  return 'https://hub.jarix.io'
}

/**
 * Fetch wrapper con manejo de errores
 */
export async function apiFetch<T>(
  endpoint: string,
  options?: RequestInit
): Promise<T> {
  const url = getApiUrl(endpoint);

  try {
    const response = await fetch(url, {
      ...options,
      headers: {
        'Content-Type': 'application/json',
        ...options?.headers,
      },
    });

    if (!response.ok) {
      throw new Error(`API Error: ${response.status} ${response.statusText}`);
    }

    return await response.json();
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
    throw error;
  }
}
